import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/system';
import { Previous, useUploader } from '@europrocurement/flexy-components';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { CollectionDeDossierJsonldCollectiondossierCreated } from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { SOUS_CLIENT_SLICE_NAME, TiersAppDispatch } from '@europrocurement/l2d-domain';
import { useDispatch } from 'react-redux';
import SelectSociete from '../components/SelectSociete';
import { useParcoursFormalite, useParcoursFormalitreHeader } from '../provider';
import { parcoursFormalitePathResolver } from '../parcoursFormalitePathResolver';
import CurrentFormalityAndClient from '../components/currentFormalityAndClient';
import SelectSocieteWrapper from '../components/SelectSocieteWrapper';
import { useDossierCustomHeader } from '../../Dossiers';

const StepSelectionClient: React.FunctionComponent = function () {
    const { idFormalites, create, containerWidth, setLoading, back, validate } =
        useParcoursFormalite();

    const dispatch = useDispatch<TiersAppDispatch>();

    React.useEffect(() => {
        dispatch({
            type: `${SOUS_CLIENT_SLICE_NAME}/deletemainSelected`,
        });
        setLoading(false);
    }, [dispatch, setLoading]);

    const { clearFiles } = useUploader();

    const navigate = useNavigate();

    const onPrevious = () => {
        navigate(parcoursFormalitePathResolver('stepFormalite'));
    };

    const { changeParcoursSteps, setIsParcoursPath } = useParcoursFormalitreHeader();

    const { setProfileHeaderVisible } = useFullLayout();
    React.useEffect(() => {
        changeParcoursSteps(1);
        setProfileHeaderVisible(false);
        setIsParcoursPath(true);
        return () => {
            setIsParcoursPath(false);
            setProfileHeaderVisible(true);
        };
    }, [setProfileHeaderVisible, changeParcoursSteps, setIsParcoursPath]);

    const { setHeaderTitle, setPathOnExit } = useDossierCustomHeader();

    /**
     * If parcours is run from back, the dossier creation will be done at this step,
     * the user will land on the validation page
     *
     * @param collection CollectionDeDossierCollectiondossierRead
     */
    const handleSubmitBack = async (
        collection: CollectionDeDossierJsonldCollectiondossierCreated,
    ) => {
        // Parcours form back, validate dossier
        const res = await validate(collection);

        if (res.data.dossiers) {
            const dossier = res.data.dossiers[0];
            // Navigate to dossier validation page
            setPathOnExit(`/dossiers/${dossier.id}`);
            setHeaderTitle('');
            navigate(`/dossiers/${dossier.id}/validation`);
        } else {
            navigate(`/dossiers`);
        }
    };

    return (
        <Container maxWidth={containerWidth}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '32px',
                }}
            >
                <CurrentFormalityAndClient />
                <Previous onClick={onPrevious} />
            </Box>
            {back ? (
                <SelectSocieteWrapper
                    onSelect={async (ids, sousClients, sousClientOpere) => {
                        setLoading(true);
                        const collection = await create(
                            ids,
                            idFormalites,
                            sousClients[0],
                            sousClientOpere[0],
                        );
                        clearFiles();
                        handleSubmitBack(collection);
                    }}
                    idFormalites={idFormalites}
                />
            ) : (
                <SelectSociete
                    onSelect={async (ids, sousClients) => {
                        setLoading(true);
                        await create(ids, idFormalites, sousClients[0]);
                        clearFiles();
                        navigate(parcoursFormalitePathResolver('stepForm'));
                    }}
                    idFormalites={idFormalites}
                />
            )}
        </Container>
    );
};

export default StepSelectionClient;
